import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import Select from 'react-select';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import CopyrightIcon from '@mui/icons-material/Copyright';

const RoleDetail = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token, permissions } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [selectedOption, setSelectedOption] = useState({ value: '1', label: 'Master' });
    const [formData, setFormData] = useState({
        Name: '',
        Claims: [],
        UpdatedBy: userId,
    });

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        fetchData('RoleApi', `/RoleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111' && response.response_data) {
                    const { RoleVM } = response.response_data;
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        ...RoleVM,
                        Claims: response.response_data.Claims ? response.response_data.Claims.map((claim) => ({ ...claim })) : [],
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Role Details:', error);
                setErrorMessage('Error fetching Role Details. Please try again.');
            });
    }, [id]);

    const getClaimRange = () => {
        const startIndex = (parseInt(selectedOption.value, 10) - 1) * 5;
        const endIndex = startIndex + 4;
        return { startIndex, endIndex };
    };

    const handleDropdownChange = (newSelectedOption) => {
        setSelectedOption(newSelectedOption);
    };

    const handleChange = (index) => {
        const updatedClaims = [...formData.Claims];
        updatedClaims[index].IsSelected = !updatedClaims[index].IsSelected;
        setFormData((prevFormData) => ({ ...prevFormData, Claims: updatedClaims }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        updateData('RoleApi', `${id}`, formData, token)
            .then((response) => {
                setSuccessMessage('Record updated successfully.');
                setErrorMessage('');
                history.push('/roleDetail/'`${id}`);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setErrorMessage('');
            });

    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h6
                        className="uppercase tracking-wide text-black flex-grow linkcolor"
                        style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                    > ROLE EDIT</h6>
                    <Button
                        variant="contained"
                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                        onClick={handleSubmit}
                    >
                        Update
                    </Button>

                    <Button
                        variant="contained"
                        component={Link}
                        to="/RoleIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                    >
                        Cancel
                    </Button>
                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        Role Name
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        name="Name"
                        value={formData.Name}
                        type="text"
                        placeholder="Enter Role Name"
                        readOnly
                    />
                </div>

                <div className="w-full mb-4">
                    <div className="w-1/3 mr-3">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Select Claim Category
                        </label>
                        <Select
                            options={[
                                { value: '1', label: 'Master' },
                                { value: '2', label: 'Transaction' },
                                { value: '3', label: 'Accounts' },
                                { value: '4', label: 'Reports' },
                                { value: '5', label: 'Administration' },
                            ]}
                            value={selectedOption}
                            onChange={handleDropdownChange}
                        />
                    </div>
                </div>

                <div className="w-full mb-4">
                    <div className="w-1/3 mr-3">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Claims
                        </label>
                        {formData.Claims && formData.Claims.length > 0 ? (
                            formData.Claims
                                .map((claim, index) => {
                                    // Check if the claim should be included based on the selected dropdown option
                                    const shouldIncludeClaim = () => {
                                        const { startIndex, endIndex } = getClaimRange();
                                        return index >= startIndex && index <= endIndex;
                                    };

                                    // Only render the claim if it should be included
                                    if (shouldIncludeClaim()) {
                                        return (
                                            <div key={index} className="form-check m-1">
                                                <label htmlFor={`claimCheckbox${index}`} className="text-black">
                                                    {claim.ClaimValue}
                                                </label>
                                                <input type="hidden" name={`Claims[${index}].ClaimType`} value={claim.ClaimType} />
                                                <input type="hidden" name={`Claims[${index}].ClaimValue`} value={claim.ClaimValue} />
                                                <input type="hidden" name={`Claims[${index}].LogInClaims`} value={claim.LogInClaims} />
                                                <input
                                                    type="checkbox"
                                                    name={`Claims[${index}].IsSelected`}
                                                    id={`claimCheckbox${index}`}
                                                    className="form-check-input"
                                                    checked={claim.IsSelected}
                                                    onChange={() => handleChange(index)}
                                                    style={{ border: '1px solid black' }}
                                                />
                                            </div>
                                        );
                                    }

                                    // Return null if the claim should not be included
                                    return null;
                                })
                        ) : (
                            <p>No claims available.</p>
                        )}

                    </div>
                </div>

            </form>
        </div>
    );
};

export default RoleDetail;
